"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _invariant = _interopRequireDefault(require("invariant"));
var _redux = require("../redux");
var _AuthProvider = require("./AuthProvider");
var _authSelectors = require("./authSelectors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Auth = function Auth(props) {
  var renderProps = {
    client: props.context.client,
    status: props.status,
    error: props.error,
    session: props.session,
    profile: props.profile
  };
  if (props.component) {
    return /*#__PURE__*/(0, _react.createElement)(props.component, renderProps);
  }
  if (props.render) {
    return props.render(renderProps);
  }
  if (typeof props.children === "function") {
    return props.children(renderProps);
  }
  return (0, _invariant.default)(false, "No render prop provided to Auth component.");
};
var AuthConsumer = function AuthConsumer(props) {
  return /*#__PURE__*/_react.default.createElement(_AuthProvider.AuthContext.Consumer, null, function (context) {
    return /*#__PURE__*/_react.default.createElement(Auth, Object.assign({}, props, {
      context: context
    }));
  });
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    status: (0, _authSelectors.statusSelector)(state),
    error: (0, _authSelectors.errorSelector)(state),
    profile: (0, _authSelectors.profileSelector)(state),
    session: (0, _authSelectors.sessionSelector)(state)
  };
};
var _default = exports.default = (0, _redux.connect)(mapStateToProps)(AuthConsumer);